import { TextInput } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class BirthOrderColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.BIRTH_ORDER

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Порядковый номер при рождении',
        component: TextInput,
        defaultValue: '',
        props: {
          icon: 'search',
          allowClear: true,
        },
      },
      width: 150,
      dataIndex: 'birth_order',
      dataRender: birth_order => birth_order ? birth_order : '-',
      sort: true,
      nullSearch: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters, nullSearches }) {
    let requestFilters = []

    if (filters?.birth_order) {
      requestFilters = [{ field: 'birth_order', value: filters?.birth_order, operator: 'like_both', invalid: false }]
    }

    if (nullSearches[REGISTER_COLUMNS.BIRTH_ORDER]) {
      requestFilters = [{ field: REGISTER_COLUMNS.BIRTH_ORDER, value: '-', operator: '=', invalid: false }]
    }

    return {
      control: {
        filters: requestFilters,
      },
    }
  }
}
